import React from 'react';
import { useQuery } from '@apollo/client';

import Commenter from 'buyside/components/presentation/Feed/CommenterList/Commenter/commenter';
import CommenterPopover from 'buyside/components/presentation/Feed/CommenterList/CommenterPopover/commenterPopover';
import Skeleton, { SKELETON_WIDTHS } from 'buyside/components/presentation/Skeleton/skeleton';

import {
  AggregatedFeedItemsQuery as AggregatedFeedItemsQueryData,
  AggregatedFeedItemsQueryVariables
} from 'interfaces/graphql-typings';

const AggregatedFeedItemsQuery = require('buyside/graphql/queries/AggregatedFeedItems');

const CommenterList: React.FC<{ feedItemId: string; showCommenterName: boolean }> = ({
  feedItemId,
  showCommenterName
}) => {
  const { data, loading, error } = useQuery<
    AggregatedFeedItemsQueryData,
    AggregatedFeedItemsQueryVariables
  >(AggregatedFeedItemsQuery, { variables: { id: feedItemId } });

  if (error) throw error;
  if (loading)
    return (
      <span>
        <Skeleton width={SKELETON_WIDTHS.MEDIUM} />
        <Skeleton width={SKELETON_WIDTHS.MEDIUM} />
      </span>
    );

  const aggregatedFeedItems = data?.aggregatedFeedItems;

  //sample feed hack
  if (!aggregatedFeedItems) return null;

  // @ts-ignore
  const [first, second, ...others] = aggregatedFeedItems.edges;

  if (!first) return null;

  return (
    <div>
      <Commenter
        comment={first.node.event.eventObject}
        articleCaps
        showCommenterName={showCommenterName}
      />
      {second && others.length === 0 && ' and '}
      {second && others.length === 0 && (
        <Commenter comment={second.node.event.eventObject} showCommenterName={showCommenterName} />
      )}
      {others.length > 0 && ', '}
      {others.length > 0 && (
        <Commenter comment={second.node.event.eventObject} showCommenterName={showCommenterName} />
      )}
      {others.length > 0 && ', and '}
      {others.length === 1 && (
        <Commenter
          comment={others[0].node.event.eventObject}
          showCommenterName={showCommenterName}
        />
      )}
      {others.length > 1 && (
        <CommenterPopover
          comments={others.map(edge => edge.node.event.eventObject)}
          showCommenterName={showCommenterName}
        />
      )}{' '}
      commented on this.
    </div>
  );
};

export default CommenterList;
